export enum ShopperAgentOutboundMessageKind {
  Outreach = "outreach",
  Reply = "reply",
}
